export function serializeTable(data, key, value) {
  return data.map((item) => {
    const obj = {};
    for (let i = 0; i < item.length; i++) {
      obj[item[i][key]] = item[i][value];
    }
    return obj;
  });
}

export function deserializeTable(data) {
  const final = [];
  const keys = ["serviceDescription", "hours", "rate", "amount"];
  data.forEach((obj) => {
    const sub = [];
    keys.forEach((key) => {
      if (key === "amount" || key === "hours" || key === "rate") {
        sub.push({
          placeholder: "",
          name: key,
          value: obj[key],
          numberFormat: true,
        });
      } else if (key === "serviceDescription") {
        sub.push({
          placeholder: "",
          name: key,
          value: obj[key],
          multiline: true,
        });
      }
    });
    final.push(sub);
  });
  return final;
}
